// extracted by mini-css-extract-plugin
export default {"userDropdown":"UserDropdown_userDropdown__MXhUF","dropdownList":"UserDropdown_dropdownList__+NJRj","displayBlock":"UserDropdown_displayBlock__HQTiF"};